import React, { useState } from 'react';
import { ShowcaseContainer } from './styled';
import { useRouter } from 'next/router';
import { convertToObj, getScreenName } from '../../../Utils/helper';
import { getSearchParams } from '../../Parenting/common';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';
import ProductShowcaseNew from './ProductShowcaseNew';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import { fireEvent } from '../../../Utils/fireEvent';

const ProductShowcase = (props) => {
  const { data, productInfo, userType, articleId } = props;
  const router = useRouter();
  const [clickEffect, setClickEffect] = useState('');
  const clickHandler = (index, url) => {
    setClickEffect('lowOpacity');
    fireEvent({
      category: 'clicked_cta',
      sku_name: data?.title?.slice(0, 99) || '',
      sku_id: data?.id || '',
      cta: 'product_card_in_article',
      screen_name: getScreenName(),
      deeplink_value: data?.webUrl,
      support_variable: articleId,
    });
    const query = convertToObj(data?.webUrl?.split('?')[1]);
    setTimeout(() => {
      setClickEffect(null);
      router.push(url + getSearchParams(query), '', {
        locale: getRouterLocale(router),
      });
    }, [500]);
  };
  const eventData = {
    category: 'viewed_popup',
    parent: 'product_card_in_article',
    sku_name: data?.title?.slice(0, 99) || '',
    sku_id: data?.id || '',
    support_variable: articleId,
  };
  return (
    <ScrollWrapper data={eventData} threshold={0.9}>
      <AnchorCoverTag
        url={data?.webUrl?.split('?')[0]}
        element={{ deeplinkValue: data?.webUrl }}
        callbackFunction={clickHandler}
      >
        <ShowcaseContainer
          className={clickEffect}
          id="showcaseSection"
          fullWidth={false}
        >
          {/* {userType == "A" ? ( */}
          <ProductShowcaseNew data={data} productInfo={productInfo} />
          {/* ) : (
                        <ProductShowcaseSection>
                            <div className="imgWrapper">
                                <Image
                                    src={data?.product_image || data?.image_url}
                                    layout="fill"
                                    loading="lazy"
                                    quality={90}
                                    alt=""
                                    sizes="33vw"
                                />
                            </div>
                            <DetailsContainer>
                                <div className="topTitle">
                                    <img src={data?.tag_image} alt="" />
                                    <span>{data?.tag_name}</span>
                                </div>
                                <div>
                                    <p className="pTitle">
                                        {data?.nickname || data?.title}
                                    </p>
                                    {data?.product_feature ? (
                                        <p className="features">
                                            {data?.product_feature}
                                        </p>
                                    ) : null}
                                </div>
                                <div className="priceSection">
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <p className="price">
                                            {"₹ " + data?.price}
                                        </p>
                                        <RatingContainer>
                                            <img
                                                src={images.newFilledStar}
                                                alt=""
                                            />
                                            <p>{data?.productRating}</p>
                                            <span>
                                                {"(" + data?.ratingCount + ")"}
                                            </span>
                                        </RatingContainer>
                                    </div>

                                    <ViewStoreCta>
                                        View on Store{" "}
                                        <img
                                            src={images.arrowRedForward}
                                            alt=""
                                        />
                                    </ViewStoreCta>
                                </div>
                            </DetailsContainer>
                        </ProductShowcaseSection>
                    )} */}
        </ShowcaseContainer>
      </AnchorCoverTag>
    </ScrollWrapper>
  );
};

export default ProductShowcase;
